import React, { useState } from 'react';
import axios from 'axios';
import { ShieldCheck } from 'lucide-react';
import { API } from './constants';
import { writeSession } from './session';

const Login = ({ onLogin }) => {
  const [pass, setPass] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { passphrase: pass });
      writeSession(data.token);
      onLogin(data.token);
    } catch (ex) {
      // Surface the specific backend message (e.g. "Too many attempts. Try again in 15 minutes.")
      // so the admin knows why login failed rather than always seeing "Incorrect passphrase."
      const detail = ex?.response?.data?.detail;
      setErr(detail || 'Incorrect passphrase.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-[#faf6f0] py-16 px-6">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-black/5 p-10 shadow-sm" data-testid="admin-login-form">
        <div className="text-center mb-6">
          <ShieldCheck size={28} className="text-[#c9a961] mx-auto mb-3" strokeWidth={1.4} />
          <p className="text-[11px] tracking-[0.3em] text-[#c9a961] font-semibold mb-2">ADMIN ACCESS</p>
          <h1 className="font-serif text-3xl text-[#1c1e20]" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
            Aurelia Dashboard
          </h1>
          <div className="w-12 h-[2px] bg-[#c9a961] mx-auto mt-3" />
        </div>
        <label className="block text-[10px] tracking-[0.28em] text-[#6b6b6b] font-semibold mb-2">
          PASSPHRASE
        </label>
        <input
          type="password"
          value={pass}
          onChange={(e) => setPass(e.target.value)}
          className="w-full border border-black/15 px-4 py-3 focus:outline-none focus:border-[#c9a961] mb-4"
          autoFocus
          data-testid="admin-login-passphrase"
        />
        {err && <p className="text-rose-600 text-sm mb-3" data-testid="admin-login-error">{err}</p>}
        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="w-full bg-[#c9a961] hover:bg-[#b89751] transition-colors text-[#141618] tracking-[0.22em] text-[12px] font-semibold py-3 disabled:opacity-60"
        >
          {busy ? 'CHECKING…' : 'ENTER DASHBOARD'}
        </button>
      </form>
    </div>
  );
};

export default Login;
